import { gql } from "@apollo/client";

export const GET_ALL_GROUP_CHAT_LIST = gql`
query getGroupChats($input: GetChatsInput) {
  getChats(input: $input) {
    chatId
    chatType
    chatroomId
    chatroomName
    chimeChannelArn
  }
}`;

export const SEARCH_CHAT_LIST = gql`
query allClassroomUsers(
  $cId: UUID!
  $input: String! = "%"
  $limit: Int = null
  $offset: Int = null
  $uId: UUID!
  $sjId: UUID!
) {
  allUsers(
    filter: {
      and: [
        {
          or: [
            {
              teachersByUId: {
                some: {
                  and: [
                    {
                      teacherClassroomsByTId: {
                        some: { classroomByCId: { cId: { equalTo: $cId } } }
                      }
                    }
                    {
                      teacherSubjectsByTId: {
                        some: {
                          sjId: { equalTo: $sjId }
                          deletedAt: { isNull: true }
                        }
                      }
                    }
                  ]
                }
              }
            }
            {
              studentsByUId: {
                some: {
                  studentClassroomsBySId: {
                    some: { classroomByCId: { cId: { equalTo: $cId } } }
                  }
                }
              }
            }
          ]
        }
        { schoolAdminsByUIdExist: false }
        { uFullName: { likeInsensitive: $input } }
        { deletedAt: { isNull: true } }
        { uId: { notEqualTo: $uId } }
        { uRole: { in: [TEACHER, STUDENT] } }
      ]
    }
    first: $limit
    offset: $offset
    orderBy: U_FULL_NAME_ASC
  ) {
    nodes {
      uFullName
      uRole
      uEmailId
      uId
      teachersByUId {
        nodes {
          tAvatarUrl
          tId
          tName
          teacherClassroomsByTId {
            nodes {
              cId
            }
          }
        }
      }
      studentsByUId {
        nodes {
          sAvatarUrl
          sId
          uId
          studentClassroomsBySId {
            nodes {
              cId
            }
          }
        }
      }
    }
    totalCount
  }
}`;

export const GET_ALL_CHAT_LIST = gql`
query getIndividualChatList($input: getIndividualChatInput!) {
  getIndividualChatList(input: $input) {
    nodes {
      chatId
      from
      to
      chatroomId
      chatType
      unReadMessagesCount
      chimeChannelArn
    }
    totalCount
  }
}`;

export const ADD_INDIVIDUAL_CHAT=gql`
mutation insertIndividualChatList($input: individualInput!) {
  insertIndividualChatList(input: $input)
}`;

export const UPDATE_LAST_MESSAGE= gql`
mutation updateLastMessateForChat($chatId: UUID!, $lastMessageSendAt: Datetime!) {
  updateChatByChatId(
    input: {chatPatch: {lastMessageSendAt: $lastMessageSendAt}, chatId: $chatId}
  ) {
    clientMutationId
  }
}`;

export const UPDATE_ACTIVE_STATUS = gql`
mutation updateUserChatStstus($chatActive: Boolean!) {
  updateUserChatStstus(chatActive: $chatActive)
}`;

export const GET_CONFIGURED_SUBJECTS_CHATS = gql`
query getConfiguredSubjectsForChat($cId: UUID!, $messagingProvider: String = "WEBSOCKET") {
  getConfiguredSubjectsForChat(cId: $cId, messagingProvider: $messagingProvider) {
    sjId
    sjName
    sjOriginalName
    sjColorCode
    unreadMsgCount
    sessionExists
    subjectAvatarUrl
  }
}
`;

export const UPDATE_CHAT_READ_MARKER = gql`
  mutation updateChatReadMarker($channelArn: String!) {
    updateChatReadMarker(channelArn: $channelArn)
  }
`;
